import React from "react";

const Wrapper = ({ layout, children }) => (
  <div className="wrapper">
    {children}
  </div>
);

export default Wrapper;
